import React from 'react';
// import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum';

import { IMediaFile } from '@common/api/media';
import {
	AnnotatedFileWrapper,
	UploadedFileListItemLink,
	UploadedFileListItemText,
} from './style';

interface IAnotatedFileProps {
	file: IMediaFile;
}

function AnotatedFile({ file }: IAnotatedFileProps) {
	// const { t } = useTranslation();

	return (
		<AnnotatedFileWrapper>
			<PhotoAlbumIcon sx={{ fontSize: '24px' }} color="primary" />
			<Box width="80%">
				<Box display="flex" alignItems="center" gap="12px">
					<UploadedFileListItemText variant="body1">
						Edited by a Teacher: {file.original_name}
					</UploadedFileListItemText>
					{file.url && (
						<UploadedFileListItemLink href={file?.url} target="_blank">
							Preview
						</UploadedFileListItemLink>
					)}
				</Box>
			</Box>
		</AnnotatedFileWrapper>
	);
}

export default AnotatedFile;
